import { getComposeViewState } from 'owa-mail-reading-pane-store-conversation/lib/utils/getComposeViewState';
import {
    getSelectedTableView,
    isMultipleSelectedItemParts,
    isSingleItemSelection,
} from 'owa-mail-list-store';

export const getMailContext = (): {
    isComposing: boolean;
    isReading: boolean;
} => {
    const isComposing = !!getComposeViewState();

    return {
        isComposing,
        isReading: !isComposing && isReadingOneItem(),
    };
};

const isReadingOneItem = (): boolean => {
    const tableView = getSelectedTableView();

    // `getSelectedTableView` is typed wrong and returns `TableView | undefined`
    if (!tableView) {
        return false;
    }

    const { isInVirtualSelectAllMode } = tableView;

    const hasOneItemSelected: boolean =
        !isMultipleSelectedItemParts() &&
        isSingleItemSelection(tableView) &&
        !isInVirtualSelectAllMode;

    return hasOneItemSelected;
};
